module.exports = __webpack_public_path__ + "img/stuck_out_tongue.2cec144b.png";